

















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component<Loading>({})
export default class Loading extends Vue {
    @Prop({ type: Boolean, default: false }) public loading!: boolean
    @Prop({ type: Boolean, default: false }) public contained!: boolean
    @Prop({ type: Boolean, default: false }) public inline!: boolean
    @Prop({ type: Boolean, default: false }) public transparent!: boolean
}
